import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import PrototypeSection from "@/pages/home/components/PrototypeSection";
import HistorySection from "@/pages/home/components/HistorySection";
import EvolutionSection from "@/pages/home/components/EvolutionSection";
import WorksSection from "@/pages/home/components/WorksSection";
import CharacterSection from "@/pages/home/components/CharacterSection";
import DifferenceSection from "@/pages/home/components/DifferenceSection";
import LegendSection from "@/pages/home/components/LegendSection";
import FaqSection from "@/pages/home/components/FaqSection";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <PrototypeSection />
        <HistorySection />
        <EvolutionSection />
        <WorksSection />
        <CharacterSection />
        <DifferenceSection />
        <LegendSection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}